import { render, staticRenderFns } from "./InventroyBappebti.vue?vue&type=template&id=1878cc04"
import script from "./InventroyBappebti.vue?vue&type=script&lang=js"
export * from "./InventroyBappebti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports